import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { Link } from 'react-router';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  return (
    <nav className="hidden md:flex items-center gap-3 text-sm border-b border-neutral-200 py-1 px-3">
      {items.map((item, index) => (
        <div key={item.label} className="flex items-center gap-3">
          {index > 0 && <ChevronRightIcon className="w-3" />}
          {item.to ? (
            <Link to={item.to} className="text-sky-800 underline hover:opacity-60">
              {item.label}
            </Link>
          ) : (
            <p>{item.label}</p>
          )}
        </div>
      ))}
    </nav>
  );
};
